import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const assets = [
    "/assets/offers-2.png",
    // "/assets/background-2.jpeg",
    // "/assets/background-3.mp4",
    // "/assets/background-4.mp4",
];

const BackgroundCard = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate()

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % assets.length);
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    const currentAsset = assets[currentIndex];
    const isVideo = currentAsset.endsWith(".mp4");

    const navigateToUserLogin = () => {
        navigate('/user-details')
    }

    return (

        <div
            style={{
                overflow: 'hidden',
                width: "100%",
                height: "100vh",
                backgroundImage: `url(${currentAsset})`,
                backgroundPosition: 'center',
                backgroundSize: "cover",
                backgroundRepeat: 'no-repeat',
                backgroundOrigin: 'padding-box',
            }}
            onClick={navigateToUserLogin}
        >
        </div>
    );
};

export default BackgroundCard;